module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"success":"Settings changes successfully saved"},"et":{"success":"Settings changes successfully saved"},"ru":{"success":"Settings changes successfully saved"}}')
  delete Component.options._Ctor
}
